import { render } from "./sidePage.vue?vue&type=template&id=123a9a4e"
import script from "./sidePage.vue?vue&type=script&lang=js"
export * from "./sidePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__